/* eslint-disable */
import React, { useState } from "react";
import { Link } from "react-router-dom";

const Profiles = ({ item, category, onClick }) => {
  function isHidden(item, filtered) {
    if (!filtered || filtered === "Filter") {
      return true;
    }
    const names = item.portfolioCategories.nodes.map(
      (category) => category.name
    );
    if (!names.includes(filtered)) {
      return false;
    }
    return true;
  }

  return (
    isHidden(item, category) && (
      <li
        className={`flex flex-wrap bg-brand-cool-grey portfolio-listing-card justify-center`}
      >
        <div className="flex flex-col portfolio-member relative w-full">
          <div>
            {item.featuredImage.node.sourceUrl ? (
              <Link
                to={`/portfolio/${item.slug}`}
                key={item.id ? item.id : null}
              >
                <img src={item.featuredImage.node.sourceUrl} alt="" className="portfolio-image" />
              </Link>
            ): null}
          </div>
          {item.portfolio ? (
            <div>
              <Link
                to={`/portfolio/${item.slug}`}
                key={item.id ? item.id : null}
                className="flex flex-col relative"
              >
                <h3 className="text-brand-black pt-4 pb-1 text-brand-l lg:text-brand-4xl">{item.title}</h3>
              </Link>
              <p className="text-brand-xs text-brand-maroon ">FOUNDER // {item.portfolio.founder}</p>
            </div>
          ): null}
          {item.portfolioCategories && item.portfolioCategories.nodes ? (
            <div className="portfolio-categories hidden lg:block">
              {item.portfolioCategories.nodes.map((item) => {
                if(item.name.toLowerCase() !== "spotlight"){
                return (
                  <span
                    key={`${item.name}-${item.id}-category`}
                    className="inline-block to-uppercase mr-4 text-brand-s mb-10 border rounded-full py-2 px-3 cat uppercase text-brand-maroon cursor-pointer"
                    onClick={onClick}
                  >
                    {item.name}
                  </span>
                );
              }
              })}
            </div>
          ): null}
          {item.content ? (
            <div
              className="lg:text-brand-l text-brand-m truncate-2-ellipsis "
              dangerouslySetInnerHTML={{
                __html: item.content,
              }}
            ></div>
          ) : null}
          <div className="bg-brand-transparent text-brand-l pl-10 pr-10  bottom-0 w-full align-bottom justify-end hidden lg:flex">
            <Link
              to={`/portfolio/${item.slug}`}
              key={item.id ? item.id : null}
              className="flex items-center justify-end  w-auto  lg:inline-flex brand-link hover:text-brand-blood-orange"
            >
              <span>View</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="none"
                stroke="currentColor"
                className="ml-3 hover:text-brand-blood-orange  "
                viewBox="0 0 22 22"
              >
                <path
                  strokeWidth="1.5"
                  className="text-brand-blood-orange"
                  d="M0 10.738h20.3M9.8 20.475l10.5-9.737L9.8 1"
                ></path>
              </svg>
            </Link>
          </div>
        </div>
      </li>
    )
  );
};

export default Profiles;



// WEBPACK FOOTER //
// ./scripts/components/Portfolio/Profiles.jsx